module.exports = __webpack_public_path__ + "static/media/rejectedstamp.910a092f.svg";